/* eslint-disable @typescript-eslint/no-unused-vars */
import Router from 'next/router';
import { APP_ROUTES, IS_SERVER } from '@constants/constants';
import { appInsights } from '@/telemetry/client';
import type { IncomingMessage, ServerResponse } from 'http';

interface IRedirectUser {
  request?: IncomingMessage;
  response?: ServerResponse<IncomingMessage>;
  location?: string;
  statusMessage?: string;
}
// `?csr=1` forces a clientside redirect
// Needed because `next/link` does a fetch request instead of real navigation
export function redirectUser({ location = `${APP_ROUTES.INDEX}?csr=1`, request, response, statusMessage = undefined }: IRedirectUser = {}) {
  if (IS_SERVER && request && response) {
    // Nomally this should only trigger when the user enters urls manually
    // But lets track the event in AI
    // @ts-expect-error: NextJS types this as `IncomingMessage`
    const { url = null, headers = {}, method = null, cookies = [], ...rest } = request;
    if (statusMessage) {
      console.log(`Redirecting: ${statusMessage}`);
    }

    // Clean token cookies
    const cleanedHeaders = Object.fromEntries(Object.entries(headers).filter(([key]) => !key.includes('cookie')));
    const cleanedCookies = {
      ...cookies,
      cl_token: '...snip...',
      '.DOTNETNUKE': '...snip...'
    };

    const data = {
      name: 'redirectUser',
      properties: {
        location: location,
        url,
        method,
        headers: cleanedHeaders,
        cookies: cleanedCookies
      }
    };

    appInsights.trackEvent(data);
    response?.writeHead(307, { location, 'X-Reason': `${statusMessage}` }).end();
  } else {
    window.location.replace(location);
  }
}
